import { HTTP2Group } from '@tt2/http2';
import { getDefaultHeaders } from './defaultHeaders';

type rootServices = 'device' | 'file' | 'updateDevice' | 'auth' | 'client' | 'user';

export const http2 = new HTTP2Group<rootServices>('root', getDefaultHeaders());

export default http2;
